import SectionTitle from "../../components/SectionTitle";
import GlanceItem from "../../components/about/GlanceItem";

import DividerSrc from "../../assets/images/divider.webp";

const AboutGlanceSection = ({
  showDivider = true,
  title,
  titleSpan,
  subtitle,
  titleType = "none",
  items = [],
}) => {
  return (
    <>
      {showDivider && (
        <img src={DividerSrc} className="divide-img" alt="divider" />
      )}
      <SectionTitle
        type={titleType}
        title={title}
        spantitle={titleSpan}
        subtitle={subtitle}
      />
      <div className="about-bensensei-glance">
        {(items || []).map((item, i) => (
          <GlanceItem key={item._key || i} item={item} />
        ))}
      </div>
    </>
  );
};

export default AboutGlanceSection;
